"use strict";

exports.__esModule = true;
exports.default = void 0;
const getDisplay = () => ({
  $block
}) => $block ? "block" : "inline-block";
var _default = getDisplay;
exports.default = _default;